<template>
  <div class="app-container">
    <transition name="el-zoom-in-top">
      <div v-show="!showadd" class="filter-container">

        <el-row :gutter="10">
          <el-col :span="1.5">
            <el-button class="filter-item" type="info" icon="el-icon-back" @click="back">{{ $t('table.back') }}</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button v-if="calcPermission(permition, 1)" class="filter-item" style="margin-left: 10px;" type="primary" icon="el-icon-edit" @click="addBox()">{{ $t('table.add') }}</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" @click="handleBatchClear">批量清理箱子</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" @click="handleClears">一键清理箱子</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button v-if="calcPermission(permition, 9)" type="danger" @click="deleted()">{{ $t('table.delete') }}</el-button>
          </el-col>
          <el-col :span="3">
            <el-input v-model="listQuery.tel" placeholder="取件手机号" @change="handleTel"/>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" @click="search">搜索</el-button>
          </el-col>
        </el-row>
      </div>
    </transition>
    <transition name="el-zoom-in-top">
      <div v-show="!showadd" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="tableKey"
          :data="list"

          fit
          stripe
          highlight-current-row
          style="width: 100%;"
          @selection-change="handleSelectionChange">
          <el-table-column :label="$t('table.change')" :selectable="selectableFun" prop="Identity" type="selection" align="center" width="80px" >
            <!-- <template>
              <el-checkbox v-model="checked">备选项</el-checkbox>
            </template> -->
          </el-table-column>
          <el-table-column :label="$t('table.BoxNo')" prop="Identity" fixed="left" align="center" width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.BoxNo">{{ scope.row.BoxNo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <!-- <el-table-column :label="$t('table.boxDId')" prop="Identity" align="center" width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.DId">{{ scope.row.DId }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column> -->
          <el-table-column :label="$t('table.boxLockId')" prop="Identity" fixed="left" align="center" width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.LockId">{{ scope.row.LockId }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.boxLockNum')" prop="Identity" fixed="left" align="center" width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.LockNum">{{ scope.row.LockNum }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <!-- 箱子规格 -->
          <!-- <el-table-column :label="$t('table.boxTypeNo')" prop="Identity" align="center" width="120px">
            <template slot-scope="scope">
              <span v-if="scope.row.TypeNo">{{ scope.row.TypeNo === 'Big' ? '大' : scope.row.TypeNo === 'Mid' ? '中' : scope.row.TypeNo === 'Small' ? '小' : (scope.row.TypeNo === 'SupperBig' || scope.row.TypeNo === 'SuperBig') ? '超级大' : '--' }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column> -->
          <el-table-column :label="$t('table.memberBox')" prop="Identity" align="center" width="120px">
            <template slot-scope="scope">
              <span v-if="scope.row.IsMember">{{ scope.row.IsMember === 'Y' ? '是' : scope.row.IsMember === 'N' ? '否' : '--' }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.boxUseTotalCount')" prop="Identity" align="center" width="100px">
            <template slot-scope="scope">
              <span>{{ scope.row.UseTotalCount || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.boxTotalIncome')" prop="Identity" align="center" width="100px">
            <template slot-scope="scope">
              <span>{{ scope.row.TotalIncome || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.retCoinMoney')" prop="Identity" align="center" width="130px">
            <template slot-scope="scope">
              <span>{{ scope.row.RetCoinMoney || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.boxStatusNo')" prop="Identity" align="center" width="200px">
            <template slot-scope="scope">
              <span v-if="scope.row.StatusNo">{{ scope.row.StatusNo | filterStatus }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="是否包月箱子" align="center" width="200px">
            <template slot-scope="scope">
              <span>{{ scope.row.UserType?'包月':'非包月' }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.boxStartTime ')" prop="Identity" align="center" width="200px">
            <template slot-scope="scope">
              <span v-if="scope.row.StartTime">{{ scope.row.StartTime }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.boxTelPhone')" prop="Identity" align="center" width="200px">
            <template slot-scope="scope">
              <span v-if="scope.row.TelPhone">{{ scope.row.TelPhone }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.actions')" align="center" width="280" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button v-if="calcPermission(permition, 7)" type="primary" size="mini" @click="openbox(scope.row)">{{ $t('table.open') }}</el-button>
              <el-button v-if="calcPermission(permition, 8)" type="warning" size="mini" @click="clearbox(scope.row)">{{ $t('table.clear') }}</el-button>
              <el-button v-if="calcPermission(permition, 1)" type="primary" size="mini" @click="addBox(scope.row)">{{ $t('table.edit') }}</el-button>
              <el-button v-if="calcPermission(permition, 9)" type="danger" size="mini" @click="deleted(scope.row)">{{ $t('table.delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination v-show="total>0" :current-page="listQuery.pageIndex" :page-sizes="[10,20,50,100]" :page-size="listQuery.pageSize" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
        </div>
        <div v-show="false">{{ ids }}</div>
      </div>
    </transition>
    <transition name="el-zoom-in-bottom">
      <div v-if="showadd" class="filter-container">
        <el-row :gutter="10" class="BorderForm">
          <div class="filter-container FormTitle" style="margin-bottom:20px;">
            <span v-if="!detail">添加箱子</span>
            <span v-if="detail">编辑箱子</span>
            <el-button class="filter-item" type="info" @click="cancel">{{ $t('table.cancel') }}</el-button>
            <el-button class="filter-item" type="primary" @click="submit">{{ $t('table.submit') }}</el-button>
          </div>
          <el-col class="CommitForm">
            <el-form ref="boxForm" :rules="rules" :model="box" label-position="right" label-width="100px">
              <el-form-item :label="$t(`table.BoxNo`)" prop="BoxNo">
                <el-input v-model="box.BoxNo" :placeholder="$t(`table.BoxNo`)" type="text" maxlength="20" />
              </el-form-item>
              <!-- <el-form-item :label="$t(`table.boxTypeNo`)" prop="TypeNo">
                <el-select v-model="box.TypeNo" :placeholder="$t('table.boxTypeNo')" clearable class="filter-item">
                  <el-option v-for="item in TypeNo" :key="item.type" :label="item.value" :value="item.type"/>
                </el-select>
              </el-form-item> -->
              <el-form-item :label="$t(`table.boxLockId`)" prop="LockPlate">
                <el-input v-model="box.LockPlate" :placeholder="$t(`table.boxLockId`)" type="text" maxlength="50" />
              </el-form-item>
              <el-form-item :label="$t(`table.boxLockNum`)" prop="LockPosition">
                <el-input v-model="box.LockPosition" :placeholder="$t(`table.boxLockNum`)" type="text" maxlength="50" />
              </el-form-item>
              <el-form-item :label="$t(`table.memberBox`)" prop="IsMember">
                <el-select v-model="box.IsMember" :placeholder="$t('table.memberBox')" clearable class="filter-item">
                  <el-option v-for="item in memberBoxs" :key="item.id" :label="item.name" :value="item.id"/>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </transition>
  </div>
</template>
<script>
import { qryBoxInfo, deleteBox, batchAddDeviceBox, clearBoxInfo } from '@/api/device'
import { qryRoleInfo } from '@/api/baseModule'
import waves from '@/directive/waves' // 水波纹指令
export default {
  name: 'OrderManage',
  directives: {
    waves
  },
  filters: {
    filterStatus(value) {
      let str = ''
      switch (value) {
        case 'occupy':
          str = '占用'
          break
        case 'free':
          str = '空闲'
          break
        case 'temp':
          str = '临时占用'
          break
        case 'prohibit':
          str = '禁用'
          break
        case 'waitNotify':
          str = '等待通知'
          break
        case 'lock':
          str = '锁定'
          break
        default:
          str = ''
          break
      }
      return str
    }
  },
  props: {
    id: {
      type: Number,
      default: null
    },
    Identity: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      checked: [], // 被选中箱子
      listLoading: true,
      permition: null,
      showadd: false,
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        tel: null
      },
      queryData: {
        dId: null
      },
      rules: {
        BoxNo: [{ required: true, message: '请输入箱子编号', trigger: 'blur' }],
        TypeNo: [{ required: true, message: '请选择设备规格', trigger: 'blur' }],
        LockPlate: [{ required: true, message: '请输入场地名称', trigger: 'blur' }],
        LockPosition: [{ required: true, message: '请输入场地地址', trigger: 'blur' }],
        IsMember: [{ required: true, message: '请选择是否是会员柜子', trigger: 'blur' }]
      },
      memberBoxs: [
        {
          id: 'Y',
          name: '是'
        },
        {
          id: 'N',
          name: '否'
        }
      ],
      TypeNo: [
        {
          type: 'Small',
          value: '小'
        },
        {
          type: 'Mid',
          value: '中'
        },
        {
          type: 'Big',
          value: '大'
        },
        {
          type: 'SuperBig',
          value: '超级大'
        }
      ],
      box: {
        BoxNo: null,
        TypeNo: 'Mid',
        LockPlate: null,
        LockPosition: null,
        IsMember: null
      },
      list: null,
      sortchange: null,
      tableKey: 0,
      bookType: 'xlsx',
      bookTypeList: ['xlsx', 'csv', 'txt'],
      total: null,
      downloadLoading: false,
      detail: null,
      pageCount: 0
    }
  },
  computed: {
    ids() {
      if (this.id) {
        this.qryList()
      }
      return this.id
    }
  },
  created() {
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
        }
      })
    } else {
      qryRoleInfo().then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
          }
        })
      })
    }
    this.queryData.dId = this.id
  },
  methods: {
    // 获取箱子列表
    qryList: function() {
      this.listQuery.dId = this.id
      qryBoxInfo(this.listQuery).then(request => {
        this.list = request.LsList
        this.total = request.TotalRows
        this.listLoading = false
      })
    },
    selectableFun(row, index) {
      if (row.UserType) {
        return false
      } else {
        return true
      }
    },
    handleSizeChange(e) {
      this.listLoading = true
      this.listQuery.pageSize = e
      this.qryList()
    },
    handleCurrentChange(e) {
      this.listLoading = true
      this.listQuery.pageIndex = e
      this.qryList()
    },
    sortChange(a, b) {
      return new Date(a.ExpireTime).getTime() - new Date(b.ExpireTime).getTime()
    },
    // 搜索
    search() {
      this.qryList()
    },
    handleTel() {
      if (this.listQuery.tel === '') {
        this.listQuery.tel = null
      }
    },
    // 添加/编辑
    addBox(detail) {
      this.showadd = true
      this.detail = detail
      if (detail) {
        this.box.BoxNo = detail.BoxNo
        this.box.TypeNo = detail.TypeNo
        this.box.LockPlate = detail.LockId
        this.box.LockPosition = detail.LockNum
        this.box.IsMember = detail.IsMember
      } else {
        this.box = {}
      }
    },
    backList() {
      this.showadd = false
      this.listQuery.pageIndex = 1
      this.listLoading = true
      this.qryList()
    },
    cancel() {
      this.showadd = false
    },
    submit() {
      this.$refs.boxForm.validate(valid => {
        if (valid) {
          var query = {}
          query.devices = []
          query.devices.push(this.id)
          query.boxs = []
          this.box.TypeNo = 'Mid'
          query.boxs.push(this.box)
          console.log(this.box)
          console.log(query)
          batchAddDeviceBox(query).then(request => {
            this.listLoading = true
            this.showadd = false
            this.qryList()
            console.log(request)
          })
        }
      })
    },
    back: function() {
      this.$emit('backList1')
    },
    // 多选
    handleSelectionChange(detail) {
      console.log(detail)
      this.checked = detail.map(item => {
        return item.BoxId
      })
      console.log(this.checked)
    },
    // 删除箱子
    deleted(detail) {
      var query = []
      if (detail) {
        query.push(detail.BoxId)
        deleteBox({ boxIds: query }).then(request => {
          if (request) {
            console.log(123123123123)
            // this.$notify({
            //   type: 'success',
            //   title: '成功',
            //   message: '删除成功'
            // })
            this.$message.success('成功')
            // if (this.listQuery.pageIndex === Math.ceil((this.total - 1) / this.listQuery.pageSize)) {
            //   this.listQuery.pageIndex = Math.ceil((this.total - 1) / this.listQuery.pageSize) - 1
            // }
            this.qryList()
          }
        })
      } else {
        if (this.checked && this.checked.length > 0) {
          deleteBox({ boxIds: this.checked }).then(request => {
            console.log(request)
            this.$notify({
              type: 'success',
              title: '成功',
              message: '删除成功'
            })
            this.qryList()
          })
        } else {
          this.$message.error('请先选择箱子')
        }
      }
    },
    // 打开箱子
    openbox(detail) {
      const boxInfo = new window.proto.SocketCmd.NotifyPayStatus()
      boxInfo.setCmdcode(0x0205)
      boxInfo.setIdentity(this.$store.getters.roles.LogNo)
      boxInfo.setOppositeid(this.Identity)
      boxInfo.setOrderno(1)
      // boxInfo.setIdentity(this.Identity)
      boxInfo.setTimetoken(new window.Date().getTime())
      boxInfo.setMemo(JSON.stringify({ LockId: detail.LockId, LockNum: detail.LockNum, type: 2 }))
      this.cySocket.sendMsg(boxInfo.serializeBinary())
    },
    // 清理箱子
    clearbox(detail) {
      if (detail.UserType) {
        clearBoxInfo({ boxIds: detail.BoxId, type: 1, clearMode: 1, userType: 1 }).then(request => {
          this.$message.success('清理成功')
          this.qryList()
        })
      } else {
        clearBoxInfo({ boxIds: detail.BoxId, type: 1, clearMode: 1, userType: 0 }).then(request => {
          this.$message.success('清理成功')
          this.qryList()
        })
      }
    },
    // 批量清理箱子
    handleBatchClear() {
      if (this.checked.length > 0) {
        clearBoxInfo({
          boxIds: this.checked.join(','),
          type: 1,
          clearMode: 1,
          userType: 0
        }).then(res => {
          this.$message({
            type: 'success',
            message: '清理成功'
          })
          this.qryList()
        })
      }
    },
    // 一键清理箱子
    handleClears() {
      clearBoxInfo({
        boxIds: this.id,
        type: 1,
        clearMode: 1,
        userType: 0
      }).then(res => {
        if (res) {
          clearBoxInfo({
            boxIds: this.id,
            type: 1,
            clearMode: 1,
            userType: 1
          }).then(res => {
            this.$message.success('清理成功')
            this.qryList()
          })
        }
      })
    },
    // 导出
    handleDownload() {
    },
    handleFilter: function() {
    },
    handleCreate: function() {
    },
    headShowBindDevices: function() {
    },
    headShowBindUser: function() {
    }
  }
}
</script>
<style scoped>
</style>
